module.exports = __webpack_public_path__ + "static/EuclidTriangle-Medium-WebS-4a40d24a927f08dd96a35cdb71333432.woff";